import { HTTPClient } from "./Client";

const MonitorApi = {
    async ListarMonitoresComPaginacaoAsync(pagina, nome, email) {
        const monitoresComPaginacao = {
            Pagina: pagina,
            Nome: nome,
            Email: email
        };

        const response = await HTTPClient.post(`/Monitor/ListarMonitores`, monitoresComPaginacao);
        return response.data;
    },

    async DeletarMonitorAsync(monitorId) {
        const response = await HTTPClient.put(`/Monitor/DeletarMonitor/${monitorId}`);
        return response.data;
    },

    async ObterMonitorPorPessoaId(monitorId) {
        const response = await HTTPClient.get(`/Monitor/ObterMonitorPorId/${monitorId}`);
        return response.data;
    },

    async EditarMonitorAsync(monitorId, nomeCompleto, nomeContato, cpf, rg, dataDeNascimento, status) {
        const monitor = {
            nomeCompleto: nomeCompleto,
            nomeContato: nomeContato,
            cpf: cpf,
            rg: rg,
            dataDeNascimento: dataDeNascimento,
            status: Number(status)
        }

        const response = await HTTPClient.put(`/Monitor/AtualizarMonitor/${monitorId}`, monitor);
        return response.data;
    },
}

export default MonitorApi;